import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-engagement-rate',
    templateUrl: './engagement-rate.component.html',
    styleUrls: ['./engagement-rate.component.scss'],
    standalone: false
})
export class EngagementRateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
